/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：685__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetName: "短信",
    phoneNumber: "号码",
    smsContent: "短信内容",
    sendSms: "发送短信",
    sendSmsTooltip: "设置好“号码”“短信内容”属性的值后，调用该积木可以直接发送相应的短信内容给到相应的号码。",
    openSms: "打开短信界面",
    openSmsTooltip: "打开系统自带的发送短信界面。",
    onSendSmsSuccess: "发送成功",
    onSendSmsFailed: "发送失败",
    onReceiveSms: "收到消息",
    smsNumberNotEmpty: "发送短信时没有设置号码",
    smsContentNotEmpty: "发送短信时没有设置短信内容",
    sendSmsLog: "发送短信给{phoneNumber}",
    smsContentMinLength: "短信内容长度太短，当前值{inputValue}，最小长度{ruleValue}"
  }
}
export { r }
